/**
 * Medals (08 §2.9): pinned one at a time, each with its name and citation from
 * `GameApi.describe`. CONTINUE pins the next, then moves on. A rack below keeps what has
 * already been pinned in view.
 */

import './ceremony.css';
import type { MedalId } from '../../../meta/types';
import { box, el } from '../dom';
import { ribbon } from '../widgets/ribbonRack';
import type { Step } from './shell';
import { continueButton, stepShell } from './shell';

export const medalsStep: Step = (env, next) => {
  const medals: readonly MedalId[] = env.input.aftermath?.medals ?? [];
  const shell = stepShell('DECORATIONS');
  const stage = el('div', 'menu-medal');
  const rack = el('div', 'menu-medal-rack');
  const count = el('div', 'menu-medal-count menu-dim');
  shell.content.append(stage, count, rack);

  let index = 0;
  const pin = (): void => {
    const medal = medals[index];
    if (medal === undefined) return;
    const d = env.ctx.describe(medal);
    stage.replaceChildren(
      box('menu-medal-pin', ribbon(medal, env.ctx.describe, true)),
      el('div', 'menu-medal-name', d.name),
      el('div', 'menu-medal-citation menu-prose', d.text),
    );
    count.textContent = medals.length > 1 ? `AWARD ${index + 1} OF ${medals.length}` : '';
    // What is already on his chest stays in view while the next one goes on.
    rack.replaceChildren(...medals.slice(0, index).map((m) => ribbon(m, env.ctx.describe)));
  };

  const go = continueButton(() => {
    index++;
    if (index >= medals.length) next();
    else pin();
  });
  shell.actions.append(go);
  pin();
  return { el: shell.el, focus: go };
};
